import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import DealerLookup from "./DealerLookup/DealerLookup";
import CombinedVehicleList from "./CombinedVehicleList.jsx";
import { DealerContextProvider } from "./DealerContext.jsx";
import { InventoryContextProvider } from "./InventoryContext.jsx";
import { VehicleContextProvider } from "./VehicleContext.jsx";
import VehicleCompareList from "./VehicleCompareList.jsx";
import { useSearchParams  } from "react-router-dom";

function DataExplorer({ addDealerToRecents, username }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedTab = searchParams.get("view") || "1";
  const setSelectedTab = (key) => {
      setSearchParams((prev) => {prev.set("view", key); return prev;});
  }

  return (
    <div>
      <ToastContainer
        position="top-center"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        autoClose={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <DealerContextProvider>
        <InventoryContextProvider>
          <VehicleContextProvider>
            {/* Header and DealerSearch moved to global header */}
            <DealerLookup addDealerToRecents={addDealerToRecents} />
            {selectedTab === "1" && <CombinedVehicleList selectedTab={selectedTab} setSelectedTab={setSelectedTab} />}
            {selectedTab === "2" && <VehicleCompareList selectedTab={selectedTab} setSelectedTab={setSelectedTab} />}
            <hr />
          </VehicleContextProvider>
        </InventoryContextProvider>
      </DealerContextProvider>
    </div>
  );
}

export default DataExplorer;